import { Injectable } from '@angular/core';
import { ApiServiceBase } from '@api/abstracts';
import { Contact } from '@components/form/components/form-layout-3/model';

@Injectable({ providedIn: 'root' })
export class ContactUsService extends ApiServiceBase<Contact> {
  constructor() {
    super('contact/b2c', 'contact', 'fournierWebservice');
  }
}
